import type { RouteRecordRaw } from 'vue-router';

import { $i } from '@silae/composables/icons';
import { defaultLayoutComponents, defaultLayoutProps } from '~/pages/layout';
import { ROUTE_KEYS } from '~/router';

const HomeRoute: RouteRecordRaw = {
	path: '/',
	name: ROUTE_KEYS.HOME,
	meta: {
		label: 'home.page-title',
		auth: true,
		isFixedEntry: true,
		icon: () => $i('folders')
	},
	props: {
		...defaultLayoutProps
	},
	components: {
		default: () => import('./home.page.vue'),
		...defaultLayoutComponents
	}
};

export default HomeRoute;
